import { SignupWizard } from '@/features/auth';

export default function SignupRoute() {
  return <SignupWizard />;
}
